var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Đồng bộ thiết bị",
            visible: _vm.showSynchronizeDeviceDialog,
            width: "35%",
            "before-close": _vm.handleClose,
          },
          on: { open: _vm.handleOpen },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.dataForm,
                rules:
                  _vm.loadingDevices ||
                  _vm.loadingButton ||
                  _vm.synchronizationRunning ||
                  _vm.restoringSyncJobs
                    ? {}
                    : _vm.rules,
                "validate-on-rule-change": false,
              },
            },
            [
              _c("DeviceSynchronizationProgress", {
                attrs: {
                  job: _vm.syncJob,
                  jobs: _vm.syncJobs,
                  error: _vm.trackingError,
                  loading: _vm.restoringSyncJobs,
                },
                on: {
                  select: _vm.selectSynchronizationJob,
                  refresh: function ($event) {
                    return _vm.refreshSynchronizationJobs()
                  },
                },
              }),
              _c(
                "el-form-item",
                { attrs: { label: "Thiết bị nguồn", prop: "idDeviceOld" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Chọn thiết bị nguồn",
                        loading: _vm.loadingDevices,
                        disabled:
                          _vm.loadingDevices ||
                          _vm.loadingButton ||
                          _vm.synchronizationRunning ||
                          _vm.restoringSyncJobs,
                      },
                      on: { change: _vm.handleSourceChange },
                      model: {
                        value: _vm.dataForm.idDeviceOld,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "idDeviceOld", $$v)
                        },
                        expression: "dataForm.idDeviceOld",
                      },
                    },
                    _vm._l(_vm.listIdDevice, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.nameDevice },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Thiết bị đích", prop: "idDeviceNew" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Chọn thiết bị đích",
                        loading: _vm.loadingDevices,
                        disabled:
                          _vm.loadingDevices ||
                          _vm.loadingButton ||
                          _vm.synchronizationRunning ||
                          _vm.restoringSyncJobs,
                      },
                      model: {
                        value: _vm.dataForm.idDeviceNew,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "idDeviceNew", $$v)
                        },
                        expression: "dataForm.idDeviceNew",
                      },
                    },
                    _vm._l(_vm.listIdDevice, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: {
                            value: item.id,
                            label: item.nameDevice,
                            disabled: item.id === _vm.dataForm.idDeviceOld,
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(item.nameDevice))])]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    loading: _vm.loadingButton,
                    disabled:
                      _vm.loadingDevices ||
                      _vm.restoringSyncJobs ||
                      _vm.synchronizationRunning ||
                      _vm.listIdDevice.length < 2,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("Áp dụng")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", disabled: _vm.loadingButton },
                  on: { click: _vm.handleClose },
                },
                [_vm._v("Đóng")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }